/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsThumbUp: {
  name: 'thumb-up';
  data: string;
} = {
  name: 'thumb-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 5.135c0-1.696-1.978-2.622-3.28-1.536l-4 3.333A2 2 0 0 0 6 8.468V19a2 2 0 0 0 2 2h9.34a2 2 0 0 0 1.839-1.212l2.66-6.205a2 2 0 0 0 .161-.788V10a2 2 0 0 0-2-2h-6V5.135ZM8 8.468l4-3.333V8a2 2 0 0 0 2 2h6v2.795L17.34 19H8V8.468ZM4 8a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V8Z" fill="currentColor"/></svg>`,
};
